import React from 'react';
import { EditSMSTemplates } from './components/EditSMSTemplates';

type SMSTemplatesPageProps = {
  orderPageIdOverride?: string;
};

export const SMSTemplatesPage = ({ orderPageIdOverride }: SMSTemplatesPageProps) => (
  <EditSMSTemplates orderPageIdOverride={orderPageIdOverride} />
);
